import Head from '@/components/feature/Head';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'H漫画 - 最新H漫画在线阅读平台',
    url: 'https://hahamanga.github.io',
    description: 'H漫画收录海量优质H漫画资源，支持在线阅读与下载，每日更新最新H漫画内容，涵盖多种风格与题材。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hahamanga.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'H漫画',
    url: 'https://hahamanga.github.io',
    description: 'H漫画 - 最新H漫画在线阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@hmanga.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <Head
        title="H漫画 - 最新H漫画在线阅读平台 | 海量优质漫画每日更新"
        description="H漫画收录海量优质H漫画资源，支持在线阅读与下载，每日更新最新H漫画内容，涵盖日系、韩系、国产等多种风格与题材，为成年用户提供流畅、安全的H漫画浏览体验。"
        keywords="H漫画,H漫画在线阅读,H漫画下载,最新H漫画,H漫画网站,日本H漫画,H漫画合集"
        canonical="https://hahamanga.github.io"
        ogTitle="H漫画 - 最新H漫画在线阅读平台"
        ogDescription="H漫画收录海量优质H漫画资源，支持在线阅读与下载，每日更新最新H漫画内容。"
        ogUrl="https://hahamanga.github.io"
        jsonLd={[websiteSchema, orgSchema]}
      />

      <HeroSection />
      <CategoryNav />
      <HotRecommend />
      <LatestUpdate />
    </>
  );
}